export default __webpack_public_path__ + "static/media/Organization_Filled.d7f31f18.svg";